<template>
    <div class="baby-or-adoption">
        <b-container>
            <b-row class="d-block d-lg-none">
                <b-col class="img-wrapper text-center">
                    <b-img
                        class="main-img h-100"
                        :class="{
                            'w-100': mainImage,
                            'bordered': landingPage.home.babyOrAdoption.hasMainImageBorder
                        }"
                        :src="mainImageSrc"
                    />
                </b-col>
            </b-row>

            <b-row>
                <b-col
                    sm="12"
                    lg="7"
                >
                    <p class="headline">
                        {{ headline }}
                    </p>

                    <p class="sub-headline">
                        {{ subHeadline }}
                    </p>

                    <b-row class="my-5">
                        <b-col class="actions-wrapper">
                            <c-t-a-button
                                v-if="secondaryAction && secondaryAction.active"
                                class="cta secondary-cta mr-2 mt-2"
                                :action="secondaryAction"
                                :landing-page="landingPage"
                                variant="transparent"
                            />

                            <c-t-a-button
                                v-if="primaryAction && primaryAction.active"
                                class="cta primary-cta mt-2"
                                :action="primaryAction"
                                :landing-page="landingPage"
                            />
                        </b-col>
                    </b-row>

                    <div
                        class="content-body"
                        v-html="body"
                    />
                </b-col>

                <b-col
                    cols="5"
                    class="d-none d-lg-flex"
                >
                    <div class="img-wrapper ml-auto">
                        <b-img
                            class="main-img h-100"
                            :class="{
                                'w-100': mainImage,
                                'bordered': landingPage.home.babyOrAdoption.hasMainImageBorder
                            }"
                            :src="mainImageSrc"
                        />
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <home-footer
            :landing-page="landingPage"
            background-image-field="home.babyOrAdoption.background.publicStorageUrl"
        />
    </div>
</template>

<script>
    import "./BabyOrAdoption.scss";
    import "./BabyOrAdoption.mobile.scss";
    import "./BabyOrAdoption.tablet.scss";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import CTAButton from "../../../CTAButton/CTAButton";
    import {mapCategoryImage} from "../../../../../helpers/methods";
    import HomeFooter from "../../HomeFooter/HomeFooter";
    export default {
        name: "BabyOrAdoption",
        components: {HomeFooter, CTAButton},
        props: {
            landingPage: {
                type: LandingPageAppResource,
                default: () => {
                    return new LandingPageAppResource({});
                }
            }
        },

        computed: {
            headline() {
                return (this.landingPage.home || {}).headline;
            },

            subHeadline() {
                return (this.landingPage.home || {}).introduction;
            },

            body() {
                return (this.landingPage.home || {}).body;
            },

            actions() {
                return this.landingPage.actions;
            },

            primaryAction() {
                return this.getActionBySort(1);
            },

            secondaryAction() {
                return this.getActionBySort(2);
            },

            mainImageSrc() {
                return this.mainImage || mapCategoryImage(this.landingPage.landingPageType.slug);
            },

            mainImage() {
                return ((this.landingPage.home.babyOrAdoption || {}).mainImage || {}).publicStorageUrl;
            },
        },

        methods: {
            getActionBySort(sort) {
                if (!this.actions ) {
                    return null;
                }

                return this.actions.toArray().find(action => action.sort === sort);
            }
        }
    };
</script>
